import script from "./classDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./classDetail.vue?vue&type=script&setup=true&lang=js"

import "./classDetail.vue?vue&type=style&index=0&id=fcec8304&lang=stylus"

const __exports__ = script;

export default __exports__